import { Button } from "@/components/ui/button";

interface ActionButtonsProps {
  onRegenerateQuestions: () => void;
  onConfirmQuestions: () => void;
  hasSelectedQuestions: boolean;
}

export const ActionButtons = ({
  onRegenerateQuestions,
  onConfirmQuestions,
  hasSelectedQuestions,
}: ActionButtonsProps) => {
  return (
    <div className="flex justify-end space-x-2">
      <Button
        variant="outline"
        onClick={onRegenerateQuestions}
      >
        Generate New Questions
      </Button>
      <Button 
        onClick={onConfirmQuestions}
        disabled={!hasSelectedQuestions}
      >
        Continue to Test Creator
      </Button>
    </div>
  );
};